// Centralized business constants - E-E-A-T trust signals
export const SITE = {
  domain: "https://dealerbydcibubur.id",
  siteName: "Dealer BYD Cibubur - BYD Haka Auto",
  tagline: "Authorized BYD Dealer - Kendaraan Listrik Premium untuk Keluarga Indonesia",
};

export const SALES = {
  name: "Kiel",
  title: "Senior Sales Consultant BYD",
  experience: "6+ Tahun Pengalaman Otomotif & Kendaraan Listrik",
  phone: "082272138537",
  phoneIntl: "6282272138537",
  photo:
    "https://static.prod-images.emergentagent.com/jobs/52e05a9a-1ea1-4291-a4d0-ea12f34e831c/images/eece8ae4ddd9f3f526ccc869e28f91c46b406f59d90628b790af89dc3f37c756.png",
  credentials: [
    "Certified BYD Product Specialist",
    "Konsultan Kredit & Leasing BYD",
    "Member Gaikindo EV Community",
  ],
};

export const DEALER = {
  name: "BYD Haka Auto Cibubur",
  address:
    "Jl. Alternatif Cibubur No.41, RT.002/RW.002, Jatikarya, Kec. Jatisampurna, Kota Bekasi, Jawa Barat 17435",
  city: "Bekasi",
  region: "Jawa Barat",
  postalCode: "17435",
  country: "ID",
  latitude: -6.375712,
  longitude: 106.9130699,
  mapUrl:
    "https://www.google.com/maps/place/BYD+HAKA+Cibubur/@-6.375712,106.9130699,17z",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.9!2d106.9130699!3d-6.375712!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69930008f19b3f%3A0x4997add21746b7ce!2sBYD%20HAKA%20Cibubur!5e0!3m2!1sen!2sid!4v1700000000000",
  openHours: "Mo-Sa 08:30-17:30",
  phone: SALES.phoneIntl,
  image:
    "https://static.prod-images.emergentagent.com/jobs/52e05a9a-1ea1-4291-a4d0-ea12f34e831c/images/b0d80b3b6e77d532606fe49e8a1f7efd632ad70774f1e97898ff78a9b5097d37.png",
};

export const WA_CTA_TEXT = "Dapatkan Hitungan Kredit Terbaik";

export const buildWhatsAppLink = (customMessage) => {
  const defaultMsg = `Halo ${SALES.name}, saya tertarik untuk konsultasi BYD di ${DEALER.name}. ${WA_CTA_TEXT}.`;
  const msg = encodeURIComponent(customMessage || defaultMsg);
  return `https://wa.me/${SALES.phoneIntl}?text=${msg}`;
};
